declare const APP_CONFIG: AppConfig;

import { AppConfig } from "./app.config";

export const environment = {
	productionMode: true,
	intercomAppId: 'khnaz0xy',
	baseUrl: APP_CONFIG.baseUrl,
};